<app-menu></app-menu>

<section class="controlai-page">
  <div class="page-guide">CONTROLPS / CONTROLAI</div>

  <header class="hero-card">
    <div>
      <h1>ControlAI</h1>
      <p>Comandos inteligentes, execução assistida por IA e trilha completa de análise com validação.</p>
      <div class="hero-pills">
        <span>Comandos: {{ commandsTotalCount }}</span>
        <span>Ativos: {{ commandsActiveCount }}</span>
        <span>Transações: {{ transactionsTotalCount }}</span>
        <span>Em aberto: {{ transactionsOpenCount }}</span>
      </div>
    </div>

    <div class="hero-actions">
      <button type="button" class="btn primary" (click)="goToCommandWorkspace()">Comandos / Cadastro</button>
      <button type="button" class="btn ghost" (click)="goToTransactionWorkspace()">Análises / Transações</button>
    </div>
  </header>

  <div class="page-feedback" *ngIf="feedback" [class.error]="feedbackType === 'error'" [class.success]="feedbackType === 'success'">
    <span>{{ feedback }}</span>
    <button type="button" (click)="clearFeedback()">Fechar</button>
  </div>

  <div class="tab-toolbar">
    <div class="tab-bar">
      <button type="button" [class.active]="activeTab === 'transactions'" (click)="setActiveTab('transactions')">
        Transações e análises
      </button>
      <button type="button" [class.active]="activeTab === 'commands'" (click)="setActiveTab('commands')">
        Comandos e cadastro
      </button>
    </div>

    <div class="tab-toolbar__actions">
      <button
        type="button"
        class="btn primary"
        *ngIf="activeTab === 'commands'"
        (click)="openNewCommandModal()"
      >
        Novo comando
      </button>
      <button
        type="button"
        class="btn primary"
        *ngIf="activeTab === 'transactions'"
        (click)="resetTransactionForm()"
      >
        Nova transação
      </button>
    </div>
  </div>

  <ng-container *ngIf="activeTab === 'commands'">
    <section class="card commands-list-card">
      <div class="section-head">
        <h2>Comandos cadastrados</h2>
      </div>

      <div class="commands-kpi-row">
        <article class="commands-kpi-card">
          <small>Total de comandos</small>
          <strong>{{ commandsTotalCount }}</strong>
        </article>
        <article class="commands-kpi-card">
          <small>Comandos ativos</small>
          <strong>{{ commandsActiveCount }}</strong>
        </article>
        <article class="commands-kpi-card">
          <small>Com ControlChat</small>
          <strong>{{ commandsControlchatEnabledCount }}</strong>
        </article>
        <article class="commands-kpi-card">
          <small>Com mapa visual</small>
          <strong>{{ commandsWithVisualMapCount }}</strong>
        </article>
      </div>

      <form class="filter-row" (ngSubmit)="applyCommandFilters()">
        <label>
          Buscar comando
          <input
            type="text"
            [(ngModel)]="commandSearch"
            name="command_search"
            placeholder="Título, objetivo ou descrição"
          >
        </label>

        <label>
          Status
          <select [(ngModel)]="commandStatusFilter" name="command_status">
            <option value="ALL">Todos</option>
            <option value="ACTIVE">Ativos</option>
            <option value="INACTIVE">Inativos</option>
          </select>
        </label>

        <div class="actions filter-actions">
          <button type="submit">Aplicar filtros</button>
          <button type="button" class="ghost" (click)="clearCommandFilters()">Limpar</button>
        </div>
      </form>

      <p *ngIf="loadingCommands">Carregando comandos...</p>

      <div class="table-wrap" *ngIf="!loadingCommands">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Título</th>
              <th>Objetivo</th>
              <th>Modelo</th>
              <th>Versão</th>
              <th>Mapa visual</th>
              <th>ControlChat</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let command of commands">
              <td>{{ command.id }}</td>
              <td>{{ command.title }}</td>
              <td>{{ shortText(command.objective, 90) }}</td>
              <td>{{ command.model }}</td>
              <td>v{{ command.version || 1 }}</td>
              <td>{{ command.visual_assets_parsed?.length || 0 }} arquivo(s)</td>
              <td>{{ getCommandScopeSummary(command) }}</td>
              <td>
                <span class="badge" [class.inactive]="!command.active">{{ command.active ? 'Ativo' : 'Inativo' }}</span>
              </td>
              <td class="row-actions">
                <button type="button" class="accent" (click)="openCommandDashboard(command)">Dashboard</button>
                <button type="button" (click)="editCommand(command)">Editar</button>
                <button type="button" class="ghost" (click)="openCommandHistory(command)">Histórico</button>
              </td>
            </tr>
            <tr *ngIf="!commands.length">
              <td colspan="9">Nenhum comando cadastrado.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeTab === 'transactions'">
    <section class="workspace-grid workspace-grid--transactions">
      <article class="card">
        <div class="section-head">
          <h2>Nova transação de análise</h2>
          <button
            type="button"
            *ngIf="!isTransactionDraftActive"
            (click)="startTransaction()"
            [disabled]="startingTransaction || savingTransactionScope || !transactionForm.command_id"
          >
            {{
              startingTransaction
                ? 'Iniciando...'
                : (isSelectedTransactionCommandDossier ? 'Iniciar / continuar dossiê' : 'Realizar nova transação')
            }}
          </button>
        </div>

        <form class="transaction-form" [class.is-disabled]="!isTransactionDraftActive" (ngSubmit)="createTransaction()">
          <div class="command-version-banner" *ngIf="isTransactionDraftActive">
            Transação #{{ transactionForm.transaction_id }} iniciada em {{ formatDate(transactionForm.transaction_started_at) }}.
            <small>Preencha o escopo e clique em salvar transação para registrar o tempo de criação/escopo.</small>
          </div>

          <div class="inline-grid two-cols">
            <label>
              Reference ID
              <input
                type="text"
                [(ngModel)]="transactionForm.reference_id"
                name="tx_reference_id"
                required
                [disabled]="startingTransaction || savingTransactionScope"
              >
            </label>

            <label>
              Comando
              <select
                [(ngModel)]="transactionForm.command_id"
                name="tx_command_id"
                required
                [disabled]="isTransactionDraftActive || startingTransaction || savingTransactionScope"
              >
                <option [ngValue]="null">Selecione</option>
                <option *ngFor="let command of commands" [ngValue]="command.id">#{{ command.id }} - {{ command.title }}</option>
              </select>
            </label>
          </div>

          <div class="inline-grid two-cols" *ngIf="isSelectedTransactionCommandDossier">
            <label>
              Data dos fatos
              <input
                type="date"
                [(ngModel)]="transactionForm.facts_date"
                name="tx_facts_date"
                [disabled]="!isTransactionDraftActive || savingTransactionScope"
              >
            </label>

            <label>
              Tipo do caso
              <input type="text" value="Dossiê" disabled>
            </label>
          </div>

          <p class="transaction-dossier-hint" *ngIf="isSelectedTransactionCommandDossier">
            Para comandos do tipo dossiê, mantenha uma única transação aberta e complemente os fatos nessa mesma análise ao longo do tempo.
          </p>

          <label>
            Itens recebidos para execução (imagens, dados, contexto)
            <textarea
              [(ngModel)]="transactionForm.received_items"
              name="tx_received_items"
              rows="4"
              placeholder="Pode ser JSON ou texto livre"
              [disabled]="!isTransactionDraftActive || savingTransactionScope"
            ></textarea>
          </label>

          <label>
            Comentário inicial para análise
            <textarea
              [(ngModel)]="transactionForm.analysis_comment"
              name="tx_analysis_comment"
              rows="2"
              placeholder="Contexto adicional para a IA (opcional)"
              [disabled]="!isTransactionDraftActive || savingTransactionScope"
            ></textarea>
          </label>

          <div class="upload-box">
            <label class="upload-title">Imagens para execução</label>
            <div
              class="dropzone"
              [class.disabled]="!isTransactionDraftActive || savingTransactionScope"
              [class.dragging]="draggingTransactionImages"
              (click)="openTransactionImagePicker(txImageInput)"
              (dragover)="onTransactionImagesDragOver($event)"
              (dragleave)="onTransactionImagesDragLeave($event)"
              (drop)="onTransactionImagesDrop($event)"
            >
              <input
                #txImageInput
                type="file"
                accept="image/*"
                multiple
                (change)="onTransactionImageSelected($event)"
                hidden
              >
              <strong>Arraste imagens aqui ou clique para selecionar</strong>
              <small>Formatos de imagem · limite de 10MB por arquivo</small>
            </div>

            <div class="pending-images" *ngIf="transactionForm.images?.length">
              <article class="pending-image" *ngFor="let image of transactionForm.images; let i = index">
                <img [src]="resolveImageUrl(image.url)" [alt]="image.name || 'Imagem da transação'">
                <div>
                  <strong>{{ image.name || ('imagem-' + (i + 1)) }}</strong>
                  <small>{{ image.mime_type || 'image/*' }}</small>
                </div>
                <button type="button" class="ghost" (click)="removeTransactionImage(i)">Remover</button>
              </article>
            </div>
          </div>

          <div class="actions">
            <button
              type="submit"
              *ngIf="isTransactionDraftActive"
              [disabled]="creatingTransaction || savingTransactionScope || uploadingTransactionImages"
            >
              {{
                uploadingTransactionImages
                  ? 'Enviando imagens...'
                  : (creatingTransaction ? 'Salvando...' : 'Salvar transação')
              }}
            </button>
          </div>
        </form>
      </article>

      <article class="card">
        <div class="section-head">
          <h2>Filtros da lista de análises</h2>
        </div>

        <form class="filter-grid" (ngSubmit)="applyTransactionFilters()">
          <label>
            Command
            <select [(ngModel)]="transactionFilters.command_id" name="tx_filter_command">
              <option [ngValue]="null">Todos</option>
              <option *ngFor="let command of commands" [ngValue]="command.id">#{{ command.id }} - {{ command.title }}</option>
            </select>
          </label>

          <label>
            Reference ID
            <input
              type="text"
              [(ngModel)]="transactionFilters.reference_id"
              name="tx_filter_reference"
              placeholder="Ex: CAI-177..."
            >
          </label>

          <label>
            Status de execução
            <select [(ngModel)]="transactionFilters.status" name="tx_filter_status">
              <option value="">Todos</option>
              <option *ngFor="let status of transactionStatusOptions" [value]="status">{{ status }}</option>
            </select>
          </label>

          <label>
            Ciclo
            <select [(ngModel)]="transactionFilters.lifecycle_status" name="tx_filter_lifecycle">
              <option value="">Todos</option>
              <option *ngFor="let lifecycle of transactionLifecycleOptions" [value]="lifecycle">{{ lifecycle }}</option>
            </select>
          </label>

          <label>
            Validação
            <select [(ngModel)]="transactionFilters.validation_result" name="tx_filter_validation">
              <option value="">Todos</option>
              <option *ngFor="let validation of transactionValidationOptions" [value]="validation">{{ validation }}</option>
            </select>
          </label>

          <div class="actions filter-actions">
            <button type="submit">Aplicar filtros</button>
            <button type="button" class="ghost" (click)="clearTransactionFilters()">Limpar</button>
          </div>
        </form>
      </article>
    </section>

    <section class="card">
      <div class="section-head section-head--stacked">
        <h2>Lista de análises / transações</h2>
        <small>{{ transactionsTotalCount }} item(ns) retornado(s) para o filtro atual.</small>
      </div>

      <p *ngIf="loadingTransactions">Carregando transações...</p>

      <div class="transaction-list" *ngIf="!loadingTransactions">
        <article class="transaction-card" *ngFor="let tx of transactions">
          <header>
            <div>
              <h3>#{{ tx.id }} · {{ tx.reference_id }}</h3>
              <p>Comando #{{ tx.command_id }} · v{{ tx.command_version || 1 }} - {{ tx.command_title }}</p>
              <p>Usuário: {{ tx.created_by_name || 'Não identificado' }}</p>
            </div>
            <div class="badges">
              <span class="badge" [class.warn]="tx.status === 'RUNNING'" [class.error]="tx.status === 'FAILED'">{{ tx.status }}</span>
              <span class="badge" [class.correct]="tx.validation_result === 'CORRECT'" [class.incorrect]="tx.validation_result === 'INCORRECT'">{{ tx.validation_result }}</span>
              <span class="badge" [class.closed]="tx.lifecycle_status === 'CLOSED'">{{ tx.lifecycle_status || 'OPEN' }}</span>
              <span class="badge plain">Interações: {{ tx.interactions_count || 0 }}</span>
            </div>
          </header>

          <div class="tx-summary">
            <span>Início da transação: {{ formatDate(tx.transaction_started_at || tx.created_at) }}</span>
            <span>Escopo enviado: {{ formatDate(tx.scope_submitted_at) }}</span>
            <span>Tempo de criação/escopo: {{ getScopeBuildDurationLabel(tx) }}</span>
            <span>Tempo de execução IA: {{ getExecutionDurationLabel(tx) }}</span>
            <span>Tempo total da jornada: {{ getJourneyDurationLabel(tx) }}</span>
          </div>

          <div class="actions tx-toggle-actions">
            <button type="button" class="ghost" (click)="toggleTransactionDetails(tx)">
              {{ isTransactionExpanded(tx.id) ? 'Fechar detalhes' : 'Abrir detalhes' }}
            </button>
            <button
              type="button"
              (click)="reprocessTransaction(tx)"
              [disabled]="isReprocessingOverlayVisible"
            >
              {{ isReprocessingTransaction(tx.id) ? 'Reprocessando...' : 'Reprocessar análise' }}
            </button>
            <button type="button" (click)="executeTransaction(tx)" [disabled]="isExecuting(tx.id) || tx.lifecycle_status === 'CLOSED'">
              {{ isExecuting(tx.id) ? 'Executando...' : 'Executar' }}
            </button>
            <button
              type="button"
              class="ghost"
              (click)="updateTransactionLifecycle(tx, tx.lifecycle_status === 'CLOSED' ? 'OPEN' : 'CLOSED')"
              [disabled]="isUpdatingLifecycle(tx.id) || isDeleting(tx.id)"
            >
              {{
                isUpdatingLifecycle(tx.id)
                  ? 'Atualizando...'
                  : (tx.lifecycle_status === 'CLOSED' ? 'Reabrir' : 'Encerrar')
              }}
            </button>
            <button
              type="button"
              class="danger"
              (click)="deleteTransaction(tx)"
              [disabled]="isDeleting(tx.id)"
            >
              {{ isDeleting(tx.id) ? 'Excluindo...' : 'Excluir' }}
            </button>
          </div>

          <ng-container *ngIf="isTransactionExpanded(tx.id)">
            <div class="tx-detail-tabs">
              <button
                type="button"
                [class.active]="getTransactionDetailTab(tx.id) === 'overview'"
                (click)="setTransactionDetailTab(tx.id, 'overview')"
              >
                Visão geral
              </button>
              <button
                type="button"
                [class.active]="getTransactionDetailTab(tx.id) === 'validation'"
                (click)="setTransactionDetailTab(tx.id, 'validation')"
              >
                Validação
              </button>
              <button
                type="button"
                [class.active]="getTransactionDetailTab(tx.id) === 'history'"
                (click)="setTransactionDetailTab(tx.id, 'history')"
              >
                Histórico
              </button>
            </div>

            <ng-container *ngIf="getTransactionDetailTab(tx.id) === 'overview'">
              <div class="tx-overview-grid">
                <section class="tx-column">
                  <div class="tx-field">
                    <strong>Itens recebidos</strong>
                    <pre>{{ tx._receivedText || '-' }}</pre>
                  </div>

                  <div class="tx-images" *ngIf="tx._receivedImages?.length">
                    <a class="tx-image" *ngFor="let image of tx._receivedImages" [href]="resolveImageUrl(image.url)" target="_blank" rel="noopener noreferrer">
                      <img [src]="resolveImageUrl(image.url)" [alt]="image.name || 'Imagem da transação'">
                      <span>{{ image.name || 'imagem' }}</span>
                    </a>
                  </div>

                  <div class="tx-field">
                    <strong>Comentário da transação</strong>
                    <pre>{{ tx.analysis_comment || '-' }}</pre>
                  </div>
                </section>

                <section class="tx-column">
                  <div class="tx-field">
                    <strong>Resultado da transação</strong>
                    <pre>{{ tx.result_text || '-' }}</pre>
                  </div>

                  <div class="tx-field-list">
                    <div class="tx-field">
                      <strong>Status suggestion</strong>
                      <p>{{ tx.status_suggestion || '-' }}</p>
                    </div>
                    <div class="tx-field">
                      <strong>Erro</strong>
                      <p>{{ tx.error_message || '-' }}</p>
                    </div>
                    <div class="tx-field">
                      <strong>Início da transação</strong>
                      <p>{{ formatDate(tx.transaction_started_at || tx.created_at) }}</p>
                    </div>
                    <div class="tx-field">
                      <strong>Escopo enviado</strong>
                      <p>{{ formatDate(tx.scope_submitted_at) }}</p>
                    </div>
                    <div class="tx-field">
                      <strong>Tempo de criação/escopo</strong>
                      <p>{{ getScopeBuildDurationLabel(tx) }}</p>
                    </div>
                    <div class="tx-field">
                      <strong>Início da execução</strong>
                      <p>{{ formatDate(tx.execution_started_at) }}</p>
                    </div>
                    <div class="tx-field">
                      <strong>Fim da execução</strong>
                      <p>{{ formatDate(tx.execution_finished_at) }}</p>
                    </div>
                    <div class="tx-field">
                      <strong>Tempo de execução</strong>
                      <p>{{ getExecutionDurationLabel(tx) }}</p>
                    </div>
                    <div class="tx-field">
                      <strong>Tempo total da jornada</strong>
                      <p>{{ getJourneyDurationLabel(tx) }}</p>
                    </div>
                  </div>
                </section>
              </div>

              <section class="interaction-box">
                <h4>Interação contínua</h4>
                <p>Adicione comentário para refinar a análise até encerrar a transação.</p>

                <label>
                  Comentário da interação
                  <textarea
                    [(ngModel)]="interactionDrafts[tx.id]"
                    [name]="'interaction_comment_' + tx.id"
                    rows="2"
                    [disabled]="tx.lifecycle_status === 'CLOSED' || isInteracting(tx.id)"
                    placeholder="Ex: foque em riscos e traga plano de ação prático."
                  ></textarea>
                </label>

                <div class="actions">
                  <button
                    type="button"
                    (click)="interactTransaction(tx)"
                    [disabled]="tx.lifecycle_status === 'CLOSED' || isInteracting(tx.id)"
                  >
                    {{ isInteracting(tx.id) ? 'Enviando...' : 'Enviar interação' }}
                  </button>
                </div>

                <p class="closed-note" *ngIf="tx.lifecycle_status === 'CLOSED'">
                  Esta transação está encerrada. Reabra para continuar a interação.
                </p>
              </section>

            </ng-container>

            <section class="validation-box" *ngIf="getTransactionDetailTab(tx.id) === 'validation'">
              <h4>Validação do resultado / retroalimentação</h4>

              <div class="validation-grid">
                <label class="validation-grid__status">
                  Resultado
                  <select [(ngModel)]="validationDrafts[tx.id].validation_result" [name]="'validation_result_' + tx.id">
                    <option value="PENDING">Pendente</option>
                    <option value="CORRECT">Correto</option>
                    <option value="INCORRECT">Incorreto</option>
                  </select>
                </label>

                <label>
                  Observações da validação
                  <textarea
                    [(ngModel)]="validationDrafts[tx.id].validation_notes"
                    [name]="'validation_notes_' + tx.id"
                    rows="4"
                    placeholder="Descreva se o resultado atendeu ou não."
                  ></textarea>
                </label>

                <label>
                  Feedback para aprendizado (ajuste de prompt)
                  <textarea
                    [(ngModel)]="validationDrafts[tx.id].ai_feedback"
                    [name]="'ai_feedback_' + tx.id"
                    rows="4"
                    placeholder="Ex: detalhar melhor classificação por prioridade."
                  ></textarea>
                </label>
              </div>

              <div class="actions">
                <button type="button" (click)="saveValidation(tx)" [disabled]="isSavingValidation(tx.id)">
                  {{ isSavingValidation(tx.id) ? 'Salvando...' : 'Salvar validação' }}
                </button>
              </div>
            </section>

            <section class="transaction-history" *ngIf="getTransactionDetailTab(tx.id) === 'history'">
              <h4>Histórico da transação</h4>
              <p *ngIf="isLoadingTransactionHistory(tx.id)">Carregando histórico...</p>

              <div class="transaction-history-list" *ngIf="!isLoadingTransactionHistory(tx.id)">
                <article class="transaction-history-item" *ngFor="let message of getTransactionHistory(tx.id)">
                  <header>
                    <span class="badge plain">{{ message.actor_type }}</span>
                    <span>{{ formatDate(message.created_at) }}</span>
                    <small *ngIf="message.actor_type === 'USER' || message.actor_user_name">
                      Usuário: {{ message.actor_user_name || 'Não identificado' }}
                    </small>
                  </header>
                  <p>{{ message.comment_text || '-' }}</p>
                  <pre *ngIf="message.payload">{{ formatHistoryPayload(message.payload) }}</pre>
                </article>
                <p *ngIf="!getTransactionHistory(tx.id).length">Sem interações registradas ainda.</p>
              </div>
            </section>
          </ng-container>
        </article>

        <p *ngIf="!transactions.length">Nenhuma transação encontrada com os filtros selecionados.</p>
      </div>
    </section>
  </ng-container>

  <div class="controlai-modal" *ngIf="commandModalVisible">
    <div class="controlai-modal__backdrop" (click)="closeCommandModal()"></div>
    <section class="controlai-modal__panel">
      <header class="controlai-modal__header" [class.controlai-modal__header--form]="commandModalType === 'form'">
        <div class="controlai-modal__title-wrap">
          <span class="controlai-modal__eyebrow" *ngIf="commandModalType === 'form'">ControlAI · Comandos</span>
          <h2 *ngIf="commandModalType === 'form'">
            {{ commandForm.id ? ('Editar comando #' + commandForm.id) : 'Novo comando' }}
          </h2>
          <p *ngIf="commandModalType === 'form'">Configure os dados do comando e as regras de execução do módulo ControlAI.</p>
          <h2 *ngIf="commandModalType === 'history'">
            Histórico do comando #{{ selectedCommandForHistory?.id }} - {{ selectedCommandForHistory?.title }}
          </h2>
          <h2 *ngIf="commandModalType === 'dashboard'">
            Dashboard do comando #{{ selectedCommandForDashboard?.id }} - {{ selectedCommandForDashboard?.title }}
          </h2>
        </div>

        <button type="button" class="controlai-modal__close" (click)="closeCommandModal()">&times;</button>
      </header>

      <div class="controlai-modal__body" *ngIf="commandModalType === 'form'">
        <form class="command-form command-form--modal command-form--wizard" (ngSubmit)="saveCommand()">
          <div class="command-version-banner" *ngIf="commandForm.id">
            Editando comando #{{ commandForm.id }} · versão atual {{ commandForm.version || 'auto' }}
            <small>Ao salvar, a versão será incrementada automaticamente.</small>
          </div>

          <div class="command-modal-tabs">
            <button type="button" [class.active]="commandFormTab === 'initial'" (click)="setCommandFormTab('initial')">1. Inicial</button>
            <button type="button" [class.active]="commandFormTab === 'images'" (click)="setCommandFormTab('images')">2. Imagens</button>
            <button type="button" [class.active]="commandFormTab === 'flow'" (click)="setCommandFormTab('flow')">3. ControlFlow</button>
            <button type="button" [class.active]="commandFormTab === 'summary'" (click)="setCommandFormTab('summary')">4. Resumo</button>
          </div>

          <section class="command-modal-surface" *ngIf="commandFormTab === 'initial'">
            <label>
              Título do comando
              <input type="text" [(ngModel)]="commandForm.title" name="command_title" placeholder="Ex: Classificação de chamados" required>
            </label>

            <label>
              Objetivo da ação (o que você precisa)
              <textarea [(ngModel)]="commandForm.objective" name="command_objective" rows="3" required></textarea>
            </label>

            <label>
              Recursos para execução (imagens, dados etc.)
              <textarea [(ngModel)]="commandForm.available_inputs" name="command_available_inputs" rows="3"></textarea>
            </label>

            <label>
              Descrição da solicitação
              <textarea [(ngModel)]="commandForm.request_description" name="command_request_description" rows="3" placeholder="Instruções de negócio da solicitação"></textarea>
            </label>

            <label>
              Prompt base para IA
              <textarea [(ngModel)]="commandForm.prompt_template" name="command_prompt_template" rows="8" required></textarea>
            </label>

            <div class="inline-grid">
              <label>
                Modelo
                <input type="text" [(ngModel)]="commandForm.model" name="command_model" placeholder="gpt-4o-mini">
              </label>

              <label>
                Temperatura
                <input type="number" min="0" max="1.5" step="0.1" [(ngModel)]="commandForm.temperature" name="command_temperature">
              </label>

              <label class="checkbox">
                <input type="checkbox" [(ngModel)]="commandForm.is_dossier" name="command_is_dossier">
                Comando do tipo dossiê
              </label>

              <label class="checkbox">
                <input type="checkbox" [(ngModel)]="commandForm.controlchat_enabled" name="command_controlchat_enabled">
                Habilitar no ControlChat
              </label>

              <label class="checkbox">
                <input type="checkbox" [(ngModel)]="commandForm.active" name="command_active">
                Ativo
              </label>
            </div>

            <section class="controlchat-scope-box" *ngIf="commandForm.controlchat_enabled">
              <div class="controlchat-scope-box__header">
                <h3>Escopo do assistente no ControlChat</h3>
                <small>Defina quem pode ver e usar este comando como assistente virtual.</small>
              </div>

              <label class="checkbox">
                <input
                  type="checkbox"
                  [(ngModel)]="commandForm.controlchat_scope_tenant"
                  name="command_controlchat_scope_tenant"
                >
                Disponível para todo o tenant
              </label>

              <p *ngIf="loadingCommandScopeOptions">Carregando setores, departamentos e usuários...</p>

              <div class="controlchat-scope-grid" *ngIf="!loadingCommandScopeOptions">
                <article class="controlchat-scope-column">
                  <h4>Setores</h4>
                  <div class="controlchat-scope-list">
                    <label *ngFor="let sector of commandScopeOptions.sectors">
                      <input
                        type="checkbox"
                        [checked]="isCommandScopeSelected('SECTOR', sector.id)"
                        (change)="toggleCommandScope('SECTOR', sector.id, $any($event.target).checked)"
                      >
                      <span>{{ sector.name }}</span>
                    </label>
                    <small *ngIf="!commandScopeOptions.sectors.length">Nenhum setor cadastrado.</small>
                  </div>
                </article>

                <article class="controlchat-scope-column">
                  <h4>Departamentos</h4>
                  <div class="controlchat-scope-list">
                    <label *ngFor="let department of commandScopeOptions.departments">
                      <input
                        type="checkbox"
                        [checked]="isCommandScopeSelected('DEPARTMENT', department.id)"
                        (change)="toggleCommandScope('DEPARTMENT', department.id, $any($event.target).checked)"
                      >
                      <span>{{ department.name }}</span>
                    </label>
                    <small *ngIf="!commandScopeOptions.departments.length">Nenhum departamento cadastrado.</small>
                  </div>
                </article>

                <article class="controlchat-scope-column">
                  <h4>Usuários</h4>
                  <div class="controlchat-scope-list">
                    <label *ngFor="let user of commandScopeOptions.users">
                      <input
                        type="checkbox"
                        [checked]="isCommandScopeSelected('USER', user.id)"
                        (change)="toggleCommandScope('USER', user.id, $any($event.target).checked)"
                      >
                      <span>{{ user.name }}<small *ngIf="user.email"> · {{ user.email }}</small></span>
                    </label>
                    <small *ngIf="!commandScopeOptions.users.length">Nenhum usuário ativo encontrado.</small>
                  </div>
                </article>
              </div>
            </section>
          </section>

          <section class="command-modal-surface" *ngIf="commandFormTab === 'images'">
            <div class="upload-box upload-box--collapsible">
              <button type="button" class="upload-box__toggle" (click)="toggleCommandImagesBlock()">
                <span>Mapa visual fixo do comando (N imagens + descrição)</span>
                <small>{{ commandImagesBlockCollapsed ? 'Abrir bloco' : 'Fechar bloco' }}</small>
              </button>

              <ng-container *ngIf="!commandImagesBlockCollapsed">
                <div
                  class="dropzone"
                  [class.dragging]="draggingCommandImages"
                  (click)="openCommandImagePicker(commandImageInput)"
                  (dragover)="onCommandImagesDragOver($event)"
                  (dragleave)="onCommandImagesDragLeave($event)"
                  (drop)="onCommandImagesDrop($event)"
                >
                  <input
                    #commandImageInput
                    type="file"
                    accept="image/*"
                    multiple
                    (change)="onCommandImageSelected($event)"
                    hidden
                  >
                  <strong>Arraste imagens aqui ou clique para selecionar</strong>
                  <small>Cada imagem deve ter descrição, importância e ações necessárias</small>
                </div>

                <div class="command-visual-assets" *ngIf="commandForm.visual_assets?.length; else noVisualAssets">
                  <article class="command-visual-asset" *ngFor="let asset of commandForm.visual_assets; let i = index">
                    <div class="command-visual-asset__preview">
                      <img [src]="resolveImageUrl(asset.url)" [alt]="asset.name || 'Imagem de referência do comando'">
                    </div>

                    <div class="command-visual-asset__form">
                      <label>
                        Nome do arquivo
                        <input type="text" [(ngModel)]="asset.name" [name]="'command_asset_name_' + i">
                      </label>

                      <label>
                        Descrição da importância
                        <textarea [(ngModel)]="asset.description" [name]="'command_asset_description_' + i" rows="3" placeholder="O que essa imagem representa e por que é relevante."></textarea>
                      </label>

                      <div class="inline-grid two-cols">
                        <label>
                          Nível de importância
                          <input type="text" [(ngModel)]="asset.importance" [name]="'command_asset_importance_' + i" placeholder="Ex: Alta, crítica, referência obrigatória">
                        </label>

                        <label>
                          Ações necessárias de análise
                          <textarea
                            class="command-actions-textarea"
                            [(ngModel)]="asset.required_actions"
                            [name]="'command_asset_required_actions_' + i"
                            rows="4"
                            placeholder="Ex: Validar padrão, identificar risco, comparar com modelo, critérios de decisão."
                          ></textarea>
                        </label>
                      </div>
                    </div>

                    <button type="button" class="ghost" (click)="removeCommandVisualAsset(i)">Remover</button>
                  </article>
                </div>
                <ng-template #noVisualAssets>
                  <p class="command-images-empty">Nenhuma imagem adicionada ainda.</p>
                </ng-template>
              </ng-container>
            </div>
          </section>

          <section class="command-modal-surface command-flow-surface" *ngIf="commandFormTab === 'flow'">
            <div class="command-flow-head">
              <div>
                <h3>ControlFlow do assistente virtual</h3>
                <p>Defina etapas, texto de resposta, botões, ação posterior e output de cada etapa no ControlChat.</p>
              </div>
              <button type="button" class="ghost" (click)="addFlowStage()">Adicionar etapa</button>
            </div>

            <div class="command-flow-list">
              <article class="command-flow-stage" *ngFor="let stage of commandFlowStages; let stageIndex = index">
                <header class="command-flow-stage__header">
                  <strong>Etapa {{ stageIndex + 1 }}</strong>
                  <button type="button" class="danger-link" (click)="removeFlowStage(stageIndex)">Remover etapa</button>
                </header>

                <div class="inline-grid two-cols">
                  <label>
                    Código da etapa
                    <input
                      type="text"
                      [(ngModel)]="stage.id"
                      [name]="'flow_stage_id_' + stageIndex"
                      placeholder="Ex: AWAITING_SCOPE"
                    >
                  </label>
                  <label>
                    Título da etapa
                    <input
                      type="text"
                      [(ngModel)]="stage.title"
                      [name]="'flow_stage_title_' + stageIndex"
                      placeholder="Ex: Coleta de contexto"
                    >
                  </label>
                </div>

                <label>
                  Texto do assistente
                  <textarea
                    rows="2"
                    [(ngModel)]="stage.text"
                    [name]="'flow_stage_text_' + stageIndex"
                    placeholder="Texto exibido ao usuário nessa etapa."
                  ></textarea>
                </label>

                <label>
                  Output da etapa
                  <textarea
                    rows="2"
                    [(ngModel)]="stage.output"
                    [name]="'flow_stage_output_' + stageIndex"
                    placeholder="Saída esperada para registrar na transação."
                  ></textarea>
                </label>

                <div class="command-flow-buttons">
                  <div class="command-flow-buttons__head">
                    <strong>Botões da etapa</strong>
                    <button type="button" class="ghost" (click)="addFlowButton(stageIndex)">Adicionar botão</button>
                  </div>

                  <div class="command-flow-button-row" *ngFor="let button of stage.buttons; let buttonIndex = index">
                    <label>
                      Rótulo
                      <input
                        type="text"
                        [(ngModel)]="button.label"
                        [name]="'flow_button_label_' + stageIndex + '_' + buttonIndex"
                        placeholder="Texto do botão"
                      >
                    </label>
                    <label>
                      Ação
                      <input
                        type="text"
                        [(ngModel)]="button.action"
                        [name]="'flow_button_action_' + stageIndex + '_' + buttonIndex"
                        placeholder="Ex: SCOPE_MORE_YES"
                      >
                    </label>
                    <label>
                      Próxima etapa
                      <input
                        type="text"
                        [(ngModel)]="button.next_state"
                        [name]="'flow_button_next_' + stageIndex + '_' + buttonIndex"
                        placeholder="Ex: PROCESSING_SCOPE"
                      >
                    </label>
                    <label>
                      Output pós-ação
                      <input
                        type="text"
                        [(ngModel)]="button.output"
                        [name]="'flow_button_output_' + stageIndex + '_' + buttonIndex"
                        placeholder="Saída desse clique"
                      >
                    </label>
                    <button
                      type="button"
                      class="danger-link"
                      (click)="removeFlowButton(stageIndex, buttonIndex)"
                    >
                      Remover
                    </button>
                  </div>

                  <small class="command-flow-empty" *ngIf="!stage.buttons?.length">Sem botões cadastrados nessa etapa.</small>
                </div>
              </article>
            </div>
          </section>

          <section class="command-modal-surface command-summary" *ngIf="commandFormTab === 'summary'">
            <article>
              <h3>Dados principais</h3>
              <p><strong>Título:</strong> {{ commandForm.title || '-' }}</p>
              <p><strong>Objetivo:</strong> {{ commandForm.objective || '-' }}</p>
              <p><strong>Descrição:</strong> {{ commandForm.request_description || '-' }}</p>
            </article>
            <article>
              <h3>Configuração da IA</h3>
              <p><strong>Modelo:</strong> {{ commandForm.model || 'gpt-4o-mini' }}</p>
              <p><strong>Temperatura:</strong> {{ commandForm.temperature }}</p>
              <p><strong>Status:</strong> {{ commandForm.active ? 'Ativo' : 'Inativo' }}</p>
            </article>
            <article>
              <h3>Mapa visual e escopo</h3>
              <p><strong>Imagens no mapa visual:</strong> {{ commandForm.visual_assets?.length || 0 }}</p>
              <p><strong>ControlChat:</strong> {{ commandFormScopeSummary }}</p>
              <p><strong>Etapas no ControlFlow:</strong> {{ commandFlowStages.length }}</p>
              <p><strong>Prompt base:</strong></p>
              <pre>{{ commandForm.prompt_template || '-' }}</pre>
            </article>
          </section>

          <div class="actions command-modal-actions">
            <button type="button" class="ghost" (click)="closeCommandModal()">Cancelar</button>
            <button type="button" class="ghost" *ngIf="commandFormTab !== 'initial'" (click)="goToPreviousCommandFormTab()">Voltar</button>
            <button type="button" *ngIf="commandFormTab !== 'summary'" (click)="goToNextCommandFormTab()">Próxima aba</button>
            <button type="submit" *ngIf="isCommandSummaryTab" [disabled]="savingCommand || uploadingCommandImages">
              {{
                uploadingCommandImages
                  ? 'Enviando imagens...'
                  : (savingCommand ? 'Salvando...' : (commandForm.id ? 'Atualizar comando' : 'Salvar comando'))
              }}
            </button>
          </div>
        </form>
      </div>

      <div class="controlai-modal__body" *ngIf="commandModalType === 'history'">
        <div class="history-list">
          <article class="history-item" *ngFor="let item of commandHistory">
            <div class="history-meta">
              <strong>{{ item.action_type }}</strong>
              <span>{{ formatDate(item.created_at) }}</span>
              <small>Usuário: {{ item.changed_by_name || 'Sistema' }}</small>
            </div>
            <div class="history-payloads">
              <div>
                <h4>Antes</h4>
                <pre>{{ item.before_payload || '-' }}</pre>
              </div>
              <div>
                <h4>Depois</h4>
                <pre>{{ item.after_payload || '-' }}</pre>
              </div>
            </div>
          </article>
          <p *ngIf="!commandHistory.length">Sem histórico para este comando.</p>
        </div>
      </div>

      <div class="controlai-modal__body" *ngIf="commandModalType === 'dashboard'">
        <p *ngIf="loadingCommandDashboard">Carregando dashboard do comando...</p>

        <div class="command-dashboard" *ngIf="!loadingCommandDashboard && commandDashboard">
          <section class="command-dashboard__hero">
            <h3>{{ commandDashboard?.command?.title || selectedCommandForDashboard?.title || '-' }}</h3>
            <div class="command-dashboard__hero-tags">
              <span class="badge">Modelo: {{ commandDashboard?.command?.model || '-' }}</span>
              <span class="badge">Versão: v{{ commandDashboard?.command?.version || 1 }}</span>
              <span class="badge">Temperatura: {{ commandDashboard?.command?.temperature ?? '-' }}</span>
              <span class="badge" [class.inactive]="!commandDashboard?.command?.active">
                {{ commandDashboard?.command?.active ? 'Ativo' : 'Inativo' }}
              </span>
            </div>
          </section>

          <section class="command-dashboard__kpis">
            <article class="dashboard-kpi">
              <small>Transações</small>
              <strong>{{ commandDashboard?.summary?.transactions_total || 0 }}</strong>
            </article>
            <article class="dashboard-kpi">
              <small>Em aberto</small>
              <strong>{{ commandDashboard?.summary?.transactions_open || 0 }}</strong>
            </article>
            <article class="dashboard-kpi">
              <small>Pendentes</small>
              <strong>{{ commandDashboard?.summary?.execution_pending || 0 }}</strong>
            </article>
            <article class="dashboard-kpi">
              <small>Em execução</small>
              <strong>{{ commandDashboard?.summary?.execution_running || 0 }}</strong>
            </article>
            <article class="dashboard-kpi">
              <small>Finalizadas</small>
              <strong>{{ commandDashboard?.summary?.execution_done || 0 }}</strong>
            </article>
            <article class="dashboard-kpi">
              <small>Falhas</small>
              <strong>{{ commandDashboard?.summary?.execution_failed || 0 }}</strong>
            </article>
            <article class="dashboard-kpi">
              <small>Validadas</small>
              <strong>{{ commandDashboard?.summary?.validation_total || 0 }}</strong>
            </article>
            <article class="dashboard-kpi">
              <small>Acurácia</small>
              <strong>{{ formatPercent(commandDashboard?.summary?.validation_accuracy_percent) }}</strong>
            </article>
          </section>

          <section class="command-dashboard__grid">
            <article class="dashboard-panel">
              <h4>Status de execução</h4>
              <div class="dashboard-stat-list">
                <div class="dashboard-stat-item"><span>Pendente</span><strong>{{ commandDashboard?.summary?.execution_pending || 0 }}</strong></div>
                <div class="dashboard-stat-item"><span>Em execução</span><strong>{{ commandDashboard?.summary?.execution_running || 0 }}</strong></div>
                <div class="dashboard-stat-item"><span>Finalizada</span><strong>{{ commandDashboard?.summary?.execution_done || 0 }}</strong></div>
                <div class="dashboard-stat-item"><span>Falha</span><strong>{{ commandDashboard?.summary?.execution_failed || 0 }}</strong></div>
              </div>
            </article>

            <article class="dashboard-panel">
              <h4>Validação do resultado</h4>
              <div class="dashboard-stat-list">
                <div class="dashboard-stat-item"><span>Pendente</span><strong>{{ commandDashboard?.summary?.validation_pending || 0 }}</strong></div>
                <div class="dashboard-stat-item"><span>Correta</span><strong>{{ commandDashboard?.summary?.validation_correct || 0 }}</strong></div>
                <div class="dashboard-stat-item"><span>Incorreta</span><strong>{{ commandDashboard?.summary?.validation_incorrect || 0 }}</strong></div>
                <div class="dashboard-stat-item"><span>Acurácia</span><strong>{{ formatPercent(commandDashboard?.summary?.validation_accuracy_percent) }}</strong></div>
              </div>
            </article>

            <article class="dashboard-panel">
              <h4>Tempo de execução</h4>
              <div class="dashboard-stat-list">
                <div class="dashboard-stat-item"><span>Amostras</span><strong>{{ commandDashboard?.execution_time?.sampled_transactions || 0 }}</strong></div>
                <div class="dashboard-stat-item"><span>Média</span><strong>{{ formatSecondsAsDuration(commandDashboard?.execution_time?.average_seconds) }}</strong></div>
                <div class="dashboard-stat-item"><span>Menor</span><strong>{{ formatSecondsAsDuration(commandDashboard?.execution_time?.min_seconds) }}</strong></div>
                <div class="dashboard-stat-item"><span>Maior</span><strong>{{ formatSecondsAsDuration(commandDashboard?.execution_time?.max_seconds) }}</strong></div>
              </div>
            </article>

            <article class="dashboard-panel">
              <h4>Qualidade do JSON</h4>
              <div class="dashboard-stat-list">
                <div class="dashboard-stat-item"><span>JSON válido</span><strong>{{ commandDashboard?.json_insights?.parsed_transactions || 0 }}</strong></div>
                <div class="dashboard-stat-item"><span>Sem JSON válido</span><strong>{{ commandDashboard?.json_insights?.missing_or_invalid_json_transactions || 0 }}</strong></div>
                <div class="dashboard-stat-item"><span>Com classificação de risco</span><strong>{{ commandDashboard?.json_insights?.field_presence?.risk || 0 }}</strong></div>
                <div class="dashboard-stat-item"><span>Com recomendação final</span><strong>{{ commandDashboard?.json_insights?.field_presence?.recommendation || 0 }}</strong></div>
              </div>
            </article>
          </section>

          <section class="command-dashboard__grid">
            <article class="dashboard-panel">
              <h4>1) CLASSIFICAÇÃO DO RISCO</h4>
              <div class="dashboard-distribution" *ngIf="commandDashboard?.json_insights?.risk_distribution?.length; else noRiskData">
                <div class="dashboard-distribution__item" *ngFor="let item of commandDashboard.json_insights.risk_distribution">
                  <span>{{ item.label }}</span>
                  <strong>{{ item.count }} ({{ formatPercent(item.percent) }})</strong>
                </div>
              </div>
              <ng-template #noRiskData>
                <p class="dashboard-empty">Sem dados de risco no JSON das transações.</p>
              </ng-template>
            </article>

            <article class="dashboard-panel">
              <h4>2) RECOMENDAÇÃO FINAL</h4>
              <div class="dashboard-distribution" *ngIf="commandDashboard?.json_insights?.recommendation_distribution?.length; else noRecommendationData">
                <div class="dashboard-distribution__item" *ngFor="let item of commandDashboard.json_insights.recommendation_distribution">
                  <span>{{ item.label }}</span>
                  <strong>{{ item.count }} ({{ formatPercent(item.percent) }})</strong>
                </div>
              </div>
              <ng-template #noRecommendationData>
                <p class="dashboard-empty">Sem recomendações finais catalogadas.</p>
              </ng-template>
            </article>
          </section>

          <section class="dashboard-panel dashboard-panel--full">
            <h4>3) PRINCIPAIS SINAIS ENCONTRADOS</h4>
            <div class="dashboard-distribution" *ngIf="commandDashboard?.json_insights?.top_main_signals?.length; else noSignalsData">
              <div class="dashboard-distribution__item" *ngFor="let item of commandDashboard.json_insights.top_main_signals">
                <span>{{ item.label }}</span>
                <strong>{{ item.count }} ocorrência(s)</strong>
              </div>
            </div>
            <ng-template #noSignalsData>
              <p class="dashboard-empty">Sem sinais encontrados no conteúdo JSON retornado.</p>
            </ng-template>
          </section>
        </div>
      </div>
    </section>
  </div>

  <div class="controlai-processing-overlay" *ngIf="isReprocessingOverlayVisible">
    <div class="controlai-processing-overlay__content">
      <div class="controlai-processing-overlay__spinner">
        <img src="../../../assets/MIV/brand/versao 1.png" alt="ControlPS">
      </div>
      <strong>Reprocessando análise...</strong>
      <small>Criando nova transação com os dados da análise selecionada.</small>
    </div>
  </div>
</section>
